import api from "./api.js";

export default class LectureApi {
  static async getCategory(data) {
    return await api.get(`lecture-category`, data);
  }
  static async getCategoryById(id, data) {
    return await api.get(`lecture-category/${id}`, data);
  }
  static async addCategory(data) {
    return await api.post(`lecture-category`, data);
  }
  static async editCategory(id, data) {
    return await api.patch(`lecture-category/${id}`, data);
  }
  static async updateActivation(id, data) {
    return await api.patch(`lecture-category/activation/${id}`, data);
  }
  static async delcategory(data) {
    return await api.del(`lecture-category`, data);
  }

  static async getOnboarding(data) {
    return await api.get(`onboarding`, data);
  }
  static async getOnboardingById(id, data) {
    return await api.get(`onboarding/${id}`, data);
  }
  static async delOnboarding(data) {
    return await api.del(`onboarding`, data);
  }

  static async addLecture(data) {
    return await api.post(`lecture-video`, data);
  }
  static async editLecture(id, data) {
    return await api.patch(`lecture-video/${id}`, data);
  }
  static async getLecture(data) {
    return await api.get(`lecture-video`, data);
  }
  static async getLectureById(id, data) {
    return await api.get(`lecture-video/${id}`, data);
  }
  static async delLecture(data) {
    return await api.del(`lecture-video`, data);
  }
  static async activation(id, data) {
    return await api.patch(`lecture-video/activation/${id}`, data);
  }

  static async getCurriculum(data) {
    return await api.get(`lecture-curriculum`, data);
  }
  static async addCurriculum(id, data) {
    return await api.post(`lecture-curriculum/${id}`, data);
  }
  static async editCurriculum(id, data) {
    return await api.patch(`lecture-curriculum/${id}`, data);
  }
  static async delCurriculum(data) {
    return await api.del(`lecture-curriculum`, data);
  }

  static async getStudentList(data) {
    return await api.get(`member-lecture`, data);
  }
}
